import { Observable } from 'rxjs';

import { UseCase }
from '../../base/use-case';

import { DataMenuModel, MenuModel }
from '../../models/configuration/menu.model';

import { ConfigurationRepository }
from '../../repositories/configuration.repository';

export class
UpdateMenuUseCase
implements UseCase<
DataMenuModel,
MenuModel
> {

    constructor(
        private repository:
        ConfigurationRepository
    ) {}

    execute(
        params: DataMenuModel
    ):
    Observable<MenuModel> {

        return this.repository
            .updatemenu(
                params
            );
    }
}